(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drag-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-drag-scroll]:not([data-drag-scroll-init])').forEach(function (el) {
    el.setAttribute('data-drag-scroll-init', '');

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var pending = null;
    var rafId = null;
    var momentumId = null;

    /* Pointer events fire faster than the browser paints, so writing
       scrollLeft on every one of them queues up work it cannot keep up with.
       Batching to one write per frame is what makes the drag feel smooth. */
    function flush() {
      rafId = null;
      if (pending === null) return;
      el.scrollLeft = pending;
      pending = null;
    }

    function schedule(value) {
      pending = value;
      if (rafId === null) rafId = requestAnimationFrame(flush);
    }

    function stopMomentum() {
      if (!momentumId) return;
      cancelAnimationFrame(momentumId);
      momentumId = null;
      el.style.scrollSnapType = '';
    }

    function momentum() {
      velocity *= 0.94;

      if (Math.abs(velocity) < 0.4) {
        momentumId = null;
        /* Restoring snap only once the glide has settled lets it ease into
           the nearest item instead of yanking mid-motion. */
        el.style.scrollSnapType = '';
        return;
      }

      el.scrollLeft -= velocity;
      momentumId = requestAnimationFrame(momentum);
    }

    el.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      stopMomentum();
      isDown = true;
      moved = false;
      startX = event.pageX;
      lastX = event.pageX;
      startScroll = el.scrollLeft;
      lastTime = performance.now();
      velocity = 0;
      el.classList.add('is-dragging');
    });

    el.addEventListener('dragstart', function (event) {
      if (isDown) event.preventDefault();
    });

    window.addEventListener('mousemove', function (event) {
      if (!isDown) return;

      var delta = event.pageX - startX;
      if (Math.abs(delta) > 3) moved = true;

      var now = performance.now();
      var elapsed = now - lastTime;
      if (elapsed > 0) velocity = ((event.pageX - lastX) / elapsed) * 16;

      lastX = event.pageX;
      lastTime = now;
      schedule(startScroll - delta);
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');

      if (Math.abs(velocity) > 1) {
        el.style.scrollSnapType = 'none';
        momentumId = requestAnimationFrame(momentum);
      }
    });

    /* Swallow the click that ends a drag so it does not follow the link. */
    el.addEventListener(
      'click',
      function (event) {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true
    );
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["floating-logo"] && !Shopify.designMode) return;
  try {
    (function () {
    var logo = document.querySelector('.floating-logo');
    if (!logo) return;

    var footer = document.querySelector('.layout--footer-group');
    if (!footer || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            logo.setAttribute('data-floating-logo-hidden', '');
          } else {
            logo.removeAttribute('data-floating-logo-hidden');
          }
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );

    observer.observe(footer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-columns"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.menu-columns--list a[data-item="nav-text"]').forEach(function (link) {
    link.style.setProperty('color', 'var(--color--body)', 'important');
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media--variants"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('.product-media--variants--root[data-layout="thumbnails"]');

    roots.forEach(function (root) {
      var container = root.querySelector('.product-media--container');
      var items = root.querySelectorAll('.product-media--root');
      if (!container || items.length < 2) return;

      var id = root.dataset.id;
      var programmatic = false;
      var programmaticTimer;

      /* overscroll-behavior alone can't do this cleanly: "auto" hands off
         to the page scroll but with a native momentum stutter at the
         boundary, "contain" is smooth but blocks the handoff entirely.
         Manually forwarding the wheel delta to the page right at the
         boundary sidesteps the browser's native (buggy) chaining. */
      container.addEventListener(
        'wheel',
        function (event) {
          var atTop = container.scrollTop <= 0;
          var atBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 1;

          if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) {
            event.preventDefault();
            window.scrollBy({ top: event.deltaY, behavior: 'auto' });
          }
        },
        { passive: false }
      );

      var thumbsWrapper = root.querySelector('.product-media--thumbs-wrapper');
      var arrowUp = root.querySelector('.product-media--thumbs-arrow--up');
      var arrowDown = root.querySelector('.product-media--thumbs-arrow--down');

      if (thumbsWrapper && arrowUp && arrowDown) {
        var updateArrows = function () {
          var maxScroll = thumbsWrapper.scrollHeight - thumbsWrapper.clientHeight;
          arrowUp.disabled = thumbsWrapper.scrollTop <= 1;
          arrowDown.disabled = thumbsWrapper.scrollTop >= maxScroll - 1;
        };

        var scrollThumbs = function (direction) {
          var thumb = thumbsWrapper.querySelector('.product-media--thumb');
          var step = thumb ? thumb.offsetHeight + 8 : 148;
          thumbsWrapper.scrollBy({ top: direction * step, behavior: 'smooth' });
        };

        arrowUp.addEventListener('click', function () {
          scrollThumbs(-1);
        });
        arrowDown.addEventListener('click', function () {
          scrollThumbs(1);
        });
        thumbsWrapper.addEventListener('scroll', updateArrows);
        updateArrows();
      }

      var scrollToMedia = function (targetId) {
        var target = targetId && container.querySelector('[data-id="' + targetId + '"]');
        if (!target) return;

        updateCounter(targetId);
        programmatic = true;
        clearTimeout(programmaticTimer);

        // Deliberately not using target.scrollIntoView(): it scrolls every
        // scrollable ancestor needed to reveal the target, including the
        // page itself, not just this container. Computing the offset by
        // hand and calling scrollTo() on just the container keeps the
        // outer page from moving at all.
        var containerRect = container.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var offset = container.scrollTop + (targetRect.top - containerRect.top);
        container.scrollTo({ top: offset, behavior: 'smooth' });

        programmaticTimer = setTimeout(function () {
          programmatic = false;
        }, 600);
      };

      var setActiveThumb = function (targetId) {
        if (!thumbsWrapper) return;
        thumbsWrapper.querySelectorAll('.product-media--thumb').forEach(function (thumb) {
          thumb.setAttribute('aria-current', parseInt(thumb.dataset.id, 10) === targetId ? 'true' : 'false');
        });
      };

      var counterCurrent = root.querySelector('.product-media--counter-current');
      var updateCounter = function (targetId) {
        if (!counterCurrent) return;
        var target = targetId && container.querySelector('[data-id="' + targetId + '"]');
        if (!target) return;
        var index = Array.prototype.indexOf.call(items, target) + 1;
        if (index > 0) counterCurrent.textContent = index;
      };

      // Thumbnail clicks and variant changes should scroll the main image;
      // our own scroll-driven dispatch (below) must not re-trigger this, or
      // it fights the user's manual scroll on every intersection tick.
      window.addEventListener('theme:product:' + id + ':mediaChanged', function (event) {
        if (event.detail && event.detail.source === 'scroll-sync') return;
        scrollToMedia(event.detail && event.detail.id);
      });

      window.addEventListener('theme:product:' + id + ':variantChanged', function (event) {
        var variant = event.detail && event.detail.variant;
        var mediaId = variant && variant.featured_media && variant.featured_media.id;
        scrollToMedia(mediaId);
      });

      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(
        function (entries) {
          if (programmatic) return;

          var visible = entries
            .filter(function (entry) {
              return entry.isIntersecting;
            })
            .sort(function (a, b) {
              return b.intersectionRatio - a.intersectionRatio;
            })[0];

          var visibleId = visible && parseInt(visible.target.dataset.id, 10);
          if (!visibleId) return;

          setActiveThumb(visibleId);
          updateCounter(visibleId);
          window.trigger('theme:product:' + id + ':mediaChanged', { id: visibleId, source: 'scroll-sync' });
        },
        { root: container, threshold: [0.5, 0.75] }
      );

      items.forEach(function (item) {
        observer.observe(item);
      });

      var initialActive = root.querySelector('.product-media--root[data-active="true"]');
      if (initialActive) {
        updateCounter(parseInt(initialActive.dataset.id, 10));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-options"] && !Shopify.designMode) return;
  try {
    (function () {
    function getVariants(root) {
      var script = root.querySelector('[data-product-options-variants]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    function updateAvailability(root) {
      var variants = getVariants(root);
      if (!variants || !variants.length) return;

      var groups = root.querySelectorAll('.product-options--option');
      var selected = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('[data-item="radio"]:checked');
        selected.push(checked ? checked.value : null);
      });

      groups.forEach(function (group, i) {
        group.querySelectorAll('[data-item="radio"]').forEach(function (input) {
          var value = input.value;
          var matchesOthers = function (v) {
            if (v.options[i] !== value) return false;
            for (var j = 0; j < selected.length; j++) {
              if (j !== i && selected[j] !== null && v.options[j] !== selected[j]) return false;
            }
            return true;
          };
          // Two separate questions: is there a variant with this value at all
          // (given the other choices), and is any such variant in stock. Sold
          // out and "does not exist" used to look identical.
          var exists = variants.some(matchesOthers);
          var hasMatch = exists && variants.some(function (v) {
            return v.available && matchesOthers(v);
          });

          var label = input.closest('[data-item="radio-input"], [data-item="swatch"]');
          if (!label) return;
          if (hasMatch) {
            label.removeAttribute('data-unavailable');
          } else {
            label.setAttribute('data-unavailable', 'true');
          }
          if (exists) {
            label.removeAttribute('data-missing');
          } else {
            label.setAttribute('data-missing', 'true');
          }
        });
      });
    }

    function correctOtherOptions(root, changedInput) {
      var variants = getVariants(root);
      if (!variants || !variants.length) return;

      var groups = root.querySelectorAll('.product-options--option');
      var optionInputs = [];
      var selected = [];
      var valid = true;
      var changedIndex = -1;

      groups.forEach(function (group, i) {
        var checked = group.querySelector('[data-item="radio"]:checked');
        if (!checked) {
          valid = false;
          return;
        }
        optionInputs.push({ name: checked.getAttribute('data-option-name'), group: group });
        selected.push(checked.value);
        if (group.contains(changedInput)) changedIndex = i;
      });
      if (!valid || !optionInputs.length || changedIndex === -1) return;

      // Only step in when the chosen combination does not exist as a variant at
      // all. A combination that exists but is sold out stays selected, so the
      // sold-out notice and the "notify me" form show for exactly what the
      // customer picked instead of silently switching the material.
      var exists = variants.some(function (v) {
        return (
          v.options.length === selected.length &&
          v.options.every(function (val, i) {
            return val === selected[i];
          })
        );
      });
      if (exists) return;

      var fixedValue = selected[changedIndex];
      var candidates = variants.filter(function (v) {
        return v.available && v.options[changedIndex] === fixedValue;
      });
      // Nothing in stock with this value: still keep the value and land on a
      // real (sold-out) variant rather than switching the value itself.
      if (!candidates.length) {
        candidates = variants.filter(function (v) {
          return v.options[changedIndex] === fixedValue;
        });
      }
      if (!candidates.length) {
        candidates = variants.filter(function (v) {
          return v.available;
        });
      }
      if (!candidates.length) return;

      var best = candidates[0];
      var bestScore = -1;
      candidates.forEach(function (v) {
        var score = 0;
        v.options.forEach(function (val, i) {
          if (i !== changedIndex && val === selected[i]) score++;
        });
        if (score > bestScore) {
          bestScore = score;
          best = v;
        }
      });

      optionInputs.forEach(function (info, i) {
        if (i === changedIndex) return;
        if (best.options[i] === selected[i]) return;

        var input = null;
        info.group.querySelectorAll('[data-item="radio"]').forEach(function (el) {
          if (el.value === best.options[i]) input = el;
        });
        if (input) input.checked = true;
      });
    }

    document.addEventListener(
      'change',
      function (e) {
        var input = e.target;
        if (!input.matches || !input.matches('[data-item="radio"]')) return;
        var root = input.closest('product-options-element');
        if (!root) return;
        correctOtherOptions(root, input);
        updateAvailability(root);
      },
      true
    );

    var boundIds = {};

    function bindRoot(root) {
      var id = root.getAttribute('data-id');
      if (!id || boundIds[id]) return;
      boundIds[id] = true;

      window.addEventListener('theme:product:' + id + ':variantChanged', function () {
        var freshRoot = document.querySelector('product-options-element[data-id="' + id + '"]');
        if (freshRoot) updateAvailability(freshRoot);
      });
    }

    function initAvailability() {
      document.querySelectorAll('product-options-element[data-id]').forEach(function (root) {
        updateAvailability(root);
        bindRoot(root);
      });
    }

    initAvailability();
    document.addEventListener('shopify:section:load', initAvailability);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    (function () {
    var boundIds = {};

    function applyCustomPrice(id, variant) {
      if (!variant || !variant.id) return;

      var root = document.querySelector('product-price-element[data-id="' + id + '"]');
      if (!root) return;

      var mapScript = root.querySelector('[data-product-price-map]');
      if (!mapScript) return;

      var map;
      try {
        map = JSON.parse(mapScript.textContent);
      } catch (e) {
        return;
      }

      var entry = map[variant.id];
      if (!entry) return;

      var priceEl = root.querySelector('.product-price--original');
      if (priceEl) priceEl.textContent = entry.price;

      var compareEl = root.querySelector('.product-price--compare');
      if (compareEl) compareEl.textContent = entry.compare;

      var unitEl = root.querySelector('.product-price--unit-price');
      if (unitEl) unitEl.textContent = entry.unit;
    }

    function bindRoot(root) {
      var id = root.getAttribute('data-id');
      if (!id || boundIds[id]) return;
      boundIds[id] = true;

      window.addEventListener('theme:product:' + id + ':variantChanged', function (e) {
        var variant = e.detail.variant;
        queueMicrotask(function () {
          applyCustomPrice(id, variant);
        });
      });
    }

    function init() {
      document.querySelectorAll('product-price-element[data-id]').forEach(bindRoot);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
